// extracted by mini-css-extract-plugin
module.exports = {"container":"CompactLayout_container__FN3S6","compactLayout":"CompactLayout_compactLayout__2RWbD"};